import { createContext, useContext } from 'react'
import { useEncounterLockStore } from '@zustore/encounterLockStore'

type EncounterReadOnlyContextValue = {
  isEncounterReadOnly: boolean
}

const EncounterReadOnlyContext = createContext<EncounterReadOnlyContextValue>({
  isEncounterReadOnly: false
})

export const EncounterReadOnlyProvider = EncounterReadOnlyContext.Provider

/** Prefer context when inside Doctor encounter; falls back to the global lock store. */
export const useEncounterReadOnly = () => {
  const ctx = useContext(EncounterReadOnlyContext)
  const locked = useEncounterLockStore(state => state.isEncounterReadOnly)
  return {
    isEncounterReadOnly: ctx.isEncounterReadOnly || locked
  }
}
